import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import styles from "./style.module.less";
import { Breadcrumb, Layout, Menu, Avatar, Dropdown, Button } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { motion } from "framer-motion";
import { UserOutlined, DownOutlined } from "@ant-design/icons";
import { getAuthUserInfo, removeAuthUserInfo } from "@/utils/auth";

const menuItems = [
  {
    key: "audit",
    label: "审核风控",
    children: [
      { key: "user-info", label: <Link to="/audit/user-info">用户资料</Link> },
      { key: "photos", label: <Link to="/audit/photos">相册照片</Link> },
      { key: "feed", label: <Link to="/audit/feed">Feed内容</Link> },
      { key: "comments", label: <Link to="/audit/comments">评论内容</Link> },
      { key: "reports", label: <Link to="/audit/reports">举报内容</Link> },
      { key: "ban", label: <Link to="/audit/ban">封禁用户</Link> },
      { key: "messages", label: <Link to="/audit/messages">消息内容</Link> },
      { key: "media", label: <Link to="/audit/media">音视频</Link> },
    ],
  },
  {
    key: "finance",
    label: "金融管理",
    children: [
      { key: "recharge", label: <Link to="/finance/recharge">充值流水</Link> },
      { key: "withdraw", label: <Link to="/finance/withdraw">提现流水</Link> },
    ],
  },
  {
    key: "user",
    label: "用户管理",
    children: [{ key: "list", label: <Link to="/user/list">用户列表</Link> }],
  },
  {
    key: "app",
    label: "App管理",
    children: [
      { key: "upgrade", label: <Link to="/app/upgrade">App升级</Link> },
    ],
  },
];

const BasicLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 获取当前登录用户信息
  const userInfo = getAuthUserInfo();

  // 退出登录
  const handleLogout = () => {
    removeAuthUserInfo();
    navigate("/login", { replace: true });
  };

  // 下拉菜单项
  const dropdownItems = [
    {
      key: "nickname",
      label: `昵称：${userInfo?.nickname || "-"}`,
      disabled: true,
    },
    {
      key: "uid",
      label: `UID：${userInfo?.uid || "-"}`,
      disabled: true,
    },
    {
      type: "divider" as const,
    },
    {
      key: "logout",
      label: (
        <Button
          type="text"
          danger
          onClick={handleLogout}
          style={{ width: "100%", textAlign: "left" }}
        >
          退出登录
        </Button>
      ),
    },
  ];

  const handleMenuClick = ({
    key,
    keyPath,
  }: {
    key: string;
    keyPath: string[];
  }) => {
    const path = "/" + keyPath.reverse().join("/");
    navigate(path, { replace: true });
  };

  // 生成面包屑导航项
  const pathSnippets = location.pathname.split("/").filter((i) => i);

  const breadcrumbItems = [
    {
      title: <Link to="/">首页</Link>,
    },
    ...pathSnippets.map((snippet, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
      const isLast = index === pathSnippets.length - 1;
      return {
        title: isLast ? (
          <span>{snippet}</span>
        ) : (
          <Link to={url}>{snippet}</Link>
        ),
      };
    }),
  ];

  return (
    <Layout className={styles.layoutContainer}>
      <Header className={styles.header}>
        <div className={styles.logo}>运营后台</div>
        <div
          style={{
            position: "relative",
            right: 0,
            top: 0,
            paddingRight: 32,
            height: "100%",
            display: "flex",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Dropdown
            menu={{
              items: dropdownItems,
            }}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName={styles.dropdown}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#fff",
              }}
            >
              <Avatar
                src={userInfo?.avatar}
                icon={<UserOutlined />}
                style={{ marginRight: 8 }}
              />
              <span style={{ marginRight: 4 }}>
                {userInfo?.nickname || "已登录"}
              </span>
              <DownOutlined />
            </div>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        <Sider width={200} className={styles.sider}>
          <Menu
            mode="inline"
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["audit"]}
            style={{ height: "100%", borderRight: 0 }}
            items={menuItems}
            onClick={handleMenuClick}
          />
        </Sider>
        <Layout className={styles.contentLayout}>
          <Breadcrumb items={breadcrumbItems} className={styles.breadcrumb} />
          <Content className={styles.content}>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <Outlet />
            </motion.div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
export default BasicLayout;
